module.exports = __webpack_public_path__ + "static/media/galeryVinyl9.2dd93ed8.jpg";